import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { ChangeDetectorRef, Component, Inject, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { NgScrollbar } from 'ngx-scrollbar';
import { finalize } from 'rxjs/internal/operators/finalize';
import { DialogFiltroGenericoComponent } from 'src/app/components/dialog-filtro-generico/dialog-filtro-generico.component';
import { Filters } from 'src/app/components/lista-tabellare/classes/lista-tabellare-data-source';
import {
  Domande,
  InformativaAziendaleService,
} from 'src/app/services/informativa-aziendale/informativa-aziendale.service';
import { UtilityService } from 'src/app/services/utility/utility.service';
import { of } from 'rxjs';

@Component({
  selector: 'app-dialog-dd-domande',
  standalone: false,

  templateUrl: './dialog-dd-domande.component.html',
  styleUrl: './dialog-dd-domande.component.scss',
})
export class DialogDdDomandeComponent {
  @ViewChild('scrollDisponibili') scrollDispobibili!: NgScrollbar;
  @ViewChild('scrollSelezionate') scrollSelezionate!: NgScrollbar;
  @ViewChild('scrollDialog') scrollDialog!: NgScrollbar;
  constructor(
    public dialogRef: MatDialogRef<DialogDdDomandeComponent>,
    public dialog: MatDialog,
    private readonly cdRef: ChangeDetectorRef,
    private readonly utilityService: UtilityService,
    private readonly informativaAziendaleService: InformativaAziendaleService,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      sezioni: FormArray;
    },
  ) {}

  public formDomande = new FormGroup({
    sezioni: new FormArray<FormGroup<any>>([]),
  });

  get sezioniFormArray(): FormArray<FormGroup<any>> {
    return this.formDomande.get('sezioni') as FormArray<FormGroup<any>>;
  }

  public loadingDisponibili: boolean = false;
  public arrayDomandeSelFiltrati: Domande[] = [];
  public arrayDomandeSel: Domande[] = [];
  public arrayDomande: Domande[] = [];

  private _valoriFiltro: Filters[] = [];
  private _valoriFiltroSelezionati: Filters[] = [];

  private _filtri: { [key: string]: any }[] = [];

  ngAfterViewInit(): void {
    this._valoriFiltro = [];
    this._valoriFiltroSelezionati = [];

    this.arrayDomandeSel = this.data.sezioni.getRawValue()[0].domande;
    this._getDomandeInformativa();

    this.arrayDomandeSelFiltrati = [...this.arrayDomandeSel];

    const sezioniControl = this.formDomande.get('sezioni') as FormArray;
    this.sezioniFormArray.clear(); // Pulisci il formArray interno

    this.data.sezioni.controls.forEach((control) => {
      sezioniControl.push(control); // Aggiungi ogni FormGroup esistente
    });

    this.cdRef.detectChanges();
  }

  dropDomande(event: CdkDragDrop<Domande[]>) {
    const obj = this.utilityService.dropElementi(
      event,
      this.arrayDomandeSel,
      this.arrayDomandeSelFiltrati,
    );

    setTimeout(() => {
      this.scrollSelezionate.update();

      this.scrollDispobibili.update();
    }, 0);

    this.arrayDomandeSel = obj.arrayElementiSel as Domande[];
    this.arrayDomandeSelFiltrati = obj.arrayElementiSelFiltrati as Domande[];

    this.mappaDomandaInForm(event);
  }

  /**
   * Transformo la domanda in form
   * @param domanda
   */
  mappaDomandaInForm(event: CdkDragDrop<Domande[]>) {
    // SONO IN SORTING
    if (event.previousContainer === event.container) {
      return;
    }

    // STO CAMBIANDO CONTENITORE
    const domanda: Domande = event.item.data;

    const sezioniFormArray = this.formDomande.get('sezioni') as FormArray;
    const domandeFormArray = ((sezioniFormArray.controls[0] as FormGroup).controls as any)
      .domande as FormArray;

    /* SE LA DOMANDA È PRESENTE NELLA SELEZIONATI ALLORA DEVO CONSTRUIRE LA FORM PER LA DOMANDA */
    if (this.arrayDomandeSel.some((dom) => dom.id === domanda.id)) {
      const formDomanda = new FormGroup({
        chiave: new FormControl<string | undefined>(domanda.chiave || undefined),
        domanda: new FormControl<string | undefined>(domanda.domanda || undefined, [
          Validators.required,
          UtilityService.blankValidator,
        ]),

        metadati: new FormGroup({
          lineaGuida: new FormArray(
            // Se domanda.metadati.lineaGuida è definito e ha elementi, mappiamo il suo contenuto,
            // altrimenti inizializziamo con un array contenente un elemento vuoto.
            (domanda?.metadati?.lineaGuida?.length ? domanda.metadati.lineaGuida : ['']).map(
              (linea) => new FormControl(linea),
            ),
          ),
        }),

        id: new FormControl<string | undefined>(domanda.id || undefined),
        note: new FormControl<string | undefined>(domanda.note || undefined),
        obbligatorio: new FormControl<boolean>(domanda.obbligatorio || false),
        sottodomanda: new FormControl<boolean>(domanda.sottodomanda || false),
        tipo: new FormControl<string | undefined>(domanda.tipo || undefined, [
          Validators.required,
          UtilityService.blankValidator,
        ]),
        idCategoriaUnitaDiMisura: new FormControl<string | undefined>(
          domanda.idCategoriaUnitaDiMisura || undefined,
        ),
        idUnitaDiRiferimento: new FormControl<string | undefined>(
          domanda.idUnitaDiRiferimento || undefined,
        ),
        opzioni: new FormArray([]),
      });

      (domanda.opzioni || []).forEach((value, index, array) => {
        const opzioni = new FormGroup({
          chiave: new FormControl<string | undefined>(value.chiave || undefined),
          id: new FormControl<string | undefined>(value.id || undefined),
          valore: new FormControl<string | undefined>(value.valore || undefined),
        });

        (formDomanda.get('opzioni') as FormArray).push(opzioni);
      });

      domandeFormArray.push(formDomanda);
    } else {
      /* SE LA DOMANDA È NELLE DISPONIBILI ALLORA LA RIMUOVO DALLA FORM */
      const index = domandeFormArray.controls.findIndex((group: AbstractControl) => {
        const idControl = (group as FormGroup).get('id');
        return idControl && idControl.value === domanda.id;
      });

      if (index !== -1) {
        domandeFormArray.removeAt(index);
      }
    }
  }

  public apriFiltroSelezionati(filtroFrom: string) {
    // Uso un oggetto per mappare i casi e le funzioni corrispondenti
    const filterActions = {
      domande: () => this._configuraFiltri('domandaFiltroSelezione', 'tipologiaFiltroSelezione'),
    };

    // Tipo per le chiavi dell'oggetto filterActions
    type FilterActionsKey = keyof typeof filterActions;

    // Verifica se la chiave fornita è valida
    if (filtroFrom in filterActions) {
      this._filtri = filterActions[filtroFrom as FilterActionsKey]();
    }

    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltroSelezionati,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltroSelezionati = result.filtri;

        this.getElementiSelezionati(filtroFrom);
      }
    });
  }

  getElementiSelezionati(formName: string) {
    if (!this._valoriFiltroSelezionati.length) {
      this.arrayDomandeSelFiltrati = [...this.arrayDomandeSel];
    } else {
      let arrayFiltrato: any;

      arrayFiltrato = this.arrayDomandeSel;

      if (!arrayFiltrato) {
        return;
      }

      arrayFiltrato = arrayFiltrato.filter((elemento: any) => {
        return this._valoriFiltroSelezionati.every((valoreFiltro) => {
          if (valoreFiltro.chiave === 'domandaFiltroSelezione') {
            return elemento.domanda.toLowerCase().includes(valoreFiltro.values[0].toLowerCase()); // Controlla se la domanda include il valore
          } else if (valoreFiltro.chiave === 'tipologiaFiltroSelezione') {
            return valoreFiltro.values.includes(elemento.tipo);
          }

          return true; // Se il filtro non corrisponde a nessuna chiave, non filtrare
        });
      });

      this.arrayDomandeSelFiltrati = arrayFiltrato;
    }
  }

  public apriFiltro(filtroFrom: string) {
    // Uso un oggetto per mappare i casi e le funzioni corrispondenti
    const filterActions = {
      domande: () => this._configuraFiltri('domanda', 'tipo'),
    };

    // Tipo per le chiavi dell'oggetto filterActions
    type FilterActionsKey = keyof typeof filterActions;

    // Verifica se la chiave fornita è valida
    if (filtroFrom in filterActions) {
      this._filtri = filterActions[filtroFrom as FilterActionsKey]();
    }

    const dialogFiltro = this.dialog.open(DialogFiltroGenericoComponent, {
      data: {
        filtri: this._filtri,
        valoriFiltro: this._valoriFiltro,
      },
      panelClass: ['dialog-container'],
      disableClose: false,
      width: '50%',
      maxHeight: '95%',
      autoFocus: false,
    });

    dialogFiltro.afterClosed().subscribe((result) => {
      if (result) {
        this._valoriFiltro = result.filtri;

        this._getDomandeInformativa();
      }
    });
  }

  private _configuraFiltri(filtro1: string, filtro2: string) {
    return [
      {
        titolo: 'Domanda',
        forControlName: filtro1,
        input: 'text',
        larghezza: 3,
      },
      {
        titolo: 'Tipologia',
        forControlName: filtro2,
        idValueOption: 'id',
        descValueOption: 'descrizione',
        input: 'multiple-option',
        fnDatiOption: () =>
          of(
            this.informativaAziendaleService.arrayTipologiaRisposta.map((value, index) => ({
              id: value.chiave,
              descrizione: value.valore,
            })),
          ),
        riempi: true,
      },
    ];
  }

  private _getDomandeInformativa() {
    this.loadingDisponibili = true;

    this.informativaAziendaleService
      .getDomande(0, 1000, undefined, this._valoriFiltro)
      .pipe(
        finalize(() => {
          setTimeout(() => {
            this.scrollSelezionate.update();

            this.scrollDispobibili.update();
          }, 0);

          this.loadingDisponibili = false;
        }),
      )
      .subscribe({
        next: (esito) => {
          this.arrayDomande = esito.content ?? [];

          //rimuovo le azioni e buone pratiche selezionati da quelli disponibili
          this.arrayDomande = this.arrayDomande.filter(
            (domandeSel) => !this.arrayDomandeSel.some((item2) => domandeSel.id === item2.id),
          );
        },
        error: (err) => {
          console.error(err);
        },
      });
  }

  completa() {
    let formValue = this.formDomande.getRawValue();
    formValue.sezioni[0]['domande'] = this.arrayDomandeSel;

    this.dialogRef.close(formValue);
  }
}
